import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const FileUploadForm = ({ handleFileChange }) => {
  const { t } = useTranslation();

  const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    handleFileChange(e.dataTransfer.files);
  };

  return (
    <div
      className="w-100 flex justify-center rounded-lg border border-dashed border-gray-300 px-2 py-10 bg-gray-50 cursor-pointer transition hover:border-blue-400"
      onDrop={onDrop}
      onDragOver={(e) => e.preventDefault()}
      onClick={() => document.getElementById("file-upload")?.click()}
    >
      <div className="text-center">
        <CloudArrowUpIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true" />
        <div className="mt-2 flex text-sm leading-6 text-gray-600">
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            className="sr-only"
            onChange={(e) => handleFileChange(e.target.files)}
          />
          <p>{t("Upload a file or drag and drop")}</p>
        </div>
        <p className="text-xs leading-5 text-gray-600">{t("Upload to Sales CRM")}</p>
      </div>
    </div>
  );
};

export default FileUploadForm;
